// based on vc-dialog 7.5.14
import DialogWrap from './DialogWrap';
export default DialogWrap;
